import * as React from 'react'
import {TextInput} from 'react-admin'

export const baseFilters = [
    <TextInput label="Recherche" source="q" alwaysOn />
    // <TextInput label="Title" source="title" defaultValue="Hello, World!" />,
];
